import { observable, action } from "mobx";
import { HandoverExtended } from "../Handovers/Handover";
import _ from "lodash"

export interface IHandoversStore {
  awaitingHandover: HandoverExtended;

  setAwaitingHandover(handover: HandoverExtended): void;
  handoverProcessed(handoverId: string): void;
}

export class HandoversStore implements IHandoversStore {
  @observable awaitingHandover: HandoverExtended;

  @action.bound
  setAwaitingHandover(handover: HandoverExtended): void {
    this.awaitingHandover = handover;
  }

  @action.bound
  handoverProcessed(handoverId: string): void {
    if (this.awaitingHandover.id === handoverId) {
      this.awaitingHandover = null;
    }
  }
}
